import productService from "@/app/redux/product-management/product-management-service";
import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

interface IProduct {
  id: string;
  product_name: string;
}

interface ICategory {
  id: string;
  category_name: string;
  ordering_number: number | null;
  created_by: string;
  updated_by: string;
  deleted_by: string | null;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  products: IProduct[] | null;
}

interface ResponseData {
  total: number;
  pages: number;
  currentPage: number;
  categories: ICategory[];
}

export function useGetProductCategories() {
  const { data, isLoading, error } = useQuery({
    queryKey: ["get-permissions-list"],
    queryFn: async (): Promise<AxiosResponse<ResponseData>> => {
      return productService.getProductCategories();
    },
    refetchOnWindowFocus: false,
  });

  return {
    error,
    categoryList: data?.data as ResponseData,
    isLoading,
  };
}
